import { AxiosResponse } from 'axios';
import {
  call,
  put,
  select,
  StrictEffect,
  takeLatest,
} from 'redux-saga/effects';
import apiRequests from 'src/utils/api';
import apiRoutes from 'src/utils/apiRoutes';
import {
  getProjectRetainer,
  setProjectRetainerData,
  setProjectRetainerLoading,
  setProjectRetainerError,
} from './reducer';
import {
  LOCAL_STORAGE_CURRENT_CUSTOMER_KEY,
  LOCAL_STORAGE_PROJECT_UUID_KEY,
} from 'src/utils/constants';

const { get } = apiRequests;

function* getProjectRetainerSagaListener(action: any): any {
  const token = yield select((state) => state.auth.token);

  if (!token) return;

  try {
    yield put(setProjectRetainerLoading());

    const storageUuid: string | null = localStorage.getItem(
        LOCAL_STORAGE_PROJECT_UUID_KEY
    );

    const userFirstProjectUuid: string | undefined = yield select(
        (state) => state.auth.user?.projects?.[0]?.uuid
    );

    const primaryUuid = storageUuid || userFirstProjectUuid;

    const user = yield select((state: any) => state.auth.user);
    const isAdmin = user?.contact?.type !== 'contact';

    if (isAdmin && !primaryUuid) {
      yield put(setProjectRetainerData(null));
      return;
    }

    try {
      const res: AxiosResponse = yield call(
          get,
          `${apiRoutes.PROJECT_RETAINER}/${primaryUuid}`,
          undefined,
          undefined,
          true
      );

      const customerUuid = res.data.data.customer.uuid;

      if (primaryUuid) {
        try {
          const response: AxiosResponse = yield call(
              get,
              `${apiRoutes.CUSTOMERS}/${customerUuid}`
          );
          const customerObject = response.data.data;

          localStorage.setItem(
              LOCAL_STORAGE_CURRENT_CUSTOMER_KEY,
              JSON.stringify(customerObject)
          );
        } catch (error) {
          console.error('Error fetching and saving customer object:', error);
        }
      }

      yield put(setProjectRetainerData(res.data.data));
      return;
    } catch (_) {}

    if (userFirstProjectUuid && userFirstProjectUuid !== primaryUuid) {
      try {
        const fallbackRes: AxiosResponse = yield call(
            get,
            `${apiRoutes.PROJECT_RETAINER}/${userFirstProjectUuid}`,
            undefined,
            undefined,
            true
        );

        yield put(setProjectRetainerData(fallbackRes.data.data));
        return;
      } catch (_) {}
    }

    throw new Error('Project not found.');
  } catch (error) {
    yield put(setProjectRetainerError(error));
  }
}

function* projectRetainerSaga(): Generator<StrictEffect> {
  yield takeLatest(getProjectRetainer.type, getProjectRetainerSagaListener);
}

export default projectRetainerSaga;